/* eslint react/jsx-key: off */
import React from 'react';
// import {apiUrl} from '../../common/Globals';
// import {HTTP_GET, HTTP_POST} from '../../common/HttpService';
import {
  Edit,
  FormTab,
  TabbedForm,
  TextInput,
  required,
  DeleteWithConfirmButton,
  Toolbar,
  SaveButton,
  ImageField,
  ImageInput,
  SelectInput
} from 'react-admin';
import {withStyles} from '@material-ui/core';
import {styles} from './BannerCreate';

const toolbarStyles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};

const BannerEditToolbar = withStyles(toolbarStyles)(({...props}) => (
  <Toolbar {...props}>
    <SaveButton />
    {props.record.id && <DeleteWithConfirmButton />}
  </Toolbar>
));
// const PreviewImage = ({record}) => <img width={250} src={record} alt="Image Preview" />;
const bannerTypeList = [
  {id: 'customer', name: 'customer'},
  {id: 'vendor', name: 'vendor'}
];
const BannerEdit = ({classes, ...props}) => (
  <Edit title="Edit  Banner" {...props}>
    <TabbedForm toolbar={<BannerEditToolbar />}>
      <FormTab label="Banner Details">
        <TextInput disabled source="id" />
        <TextInput
          autoFocus
          source="bannerName"
          label="Banner Name"
          validate={required()}
          formClassName={classes.first_name}
        />
        <TextInput disabled source="serviceCategoryName" />
        <SelectInput source="bannerType" choices={bannerTypeList} />
      </FormTab>
      <FormTab label="Images">
        <ImageField source="bannerUrl" title="bannerUrl" />
        {/* <ImageField source="imagePath" src="imagePath" label="Service image" /> */}
        <ImageInput
          source="images"
          label="images"
          accept="image/*"
          maxSize={5000000}
          placeholder={
            <p>
              Upload Image
              <span>*File size should not exceed 5MB</span>
            </p>
          }
        >
          <ImageField source="url" title="title" />
        </ImageInput>
      </FormTab>
    </TabbedForm>
  </Edit>
);

BannerEdit.propTypes = {};

export default withStyles(styles)(BannerEdit);
